import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GroupTenantPermissions, UserTenantPermissions } from '../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TenantPrivilegesResource {
  private _http = inject(HttpClient);

  getUsers(tenantId: string | number): Observable<UserTenantPermissions[]> {
    return this._http.get<UserTenantPermissions[]>(`/services/microsoft/admin/tenants/${tenantId}/permissions/users`);
  }

  postUser(tenantId: string | number, user: UserTenantPermissions): Observable<UserTenantPermissions> {
    return this._http.post<UserTenantPermissions>(
      `/services/microsoft/admin/tenants/${tenantId}/permissions/users`,
      user,
    );
  }

  putUser(tenantId: string | number, user: UserTenantPermissions): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/admin/tenants/${tenantId}/permissions/users/${encodeURIComponent(user.upn)}`,
      user,
    );
  }

  deleteUser(tenantId: string | number, upn: string): Observable<void> {
    return this._http.delete<void>(
      `/services/microsoft/admin/tenants/${tenantId}/permissions/users/${encodeURIComponent(upn)}`,
    );
  }

  getGroups(tenantId: string | number): Observable<GroupTenantPermissions[]> {
    return this._http.get<GroupTenantPermissions[]>(`/services/microsoft/admin/tenants/${tenantId}/permissions/groups`);
  }

  postGroup(tenantId: string | number, group: GroupTenantPermissions): Observable<GroupTenantPermissions> {
    return this._http.post<GroupTenantPermissions>(
      `/services/microsoft/admin/tenants/${tenantId}/permissions/groups`,
      group,
    );
  }

  putGroup(tenantId: string | number, group: GroupTenantPermissions): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/admin/tenants/${tenantId}/permissions/groups/tenant-guids/${group.groupTenantGuid}/display-names/${encodeURIComponent(group.displayName)}`,
      group,
    );
  }

  deleteGroup(tenantId: string | number, groupTenantGuid: string, displayName: string): Observable<void> {
    return this._http.delete<void>(
      `/services/microsoft/admin/tenants/${tenantId}/permissions/groups/tenant-guids/${groupTenantGuid}/display-names/${encodeURIComponent(displayName)}`,
    );
  }
}
